/**
 * Placeholder shapes for the profile surfaces: the info card (own profile,
 * other profiles, portrait) so the page keeps its frame while data loads.
 */
import { Skeleton, SkeletonGroup } from '../../components/ui/Skeleton';
import './profile.css';

export function ProfileCardSkeleton() {
  return (
    <SkeletonGroup className="profile-card">
      <div className="profile-card__identity">
        <Skeleton shape="circle" className="profile-skeleton__avatar" />
        <div className="profile-card__identity-text profile-skeleton__identity">
          <Skeleton className="profile-skeleton__line profile-skeleton__line--name" />
          <Skeleton className="profile-skeleton__line profile-skeleton__line--bio" />
        </div>
      </div>
      <Skeleton shape="rect" className="profile-skeleton__stats" />
      <div className="profile-skeleton__actions">
        <Skeleton shape="rect" className="profile-skeleton__button" />
        <Skeleton shape="rect" className="profile-skeleton__button" />
      </div>
    </SkeletonGroup>
  );
}
